import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getFifthAnalyses = asyncThunkWrapper({ 
  model: 'fifthAnalyses', 
  action: 'getFifthAnalyses', 
  func: async ({ offset = 0 }) => {
    const attributes = ['id', 'input', 'status', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'desc' }, attributes };
    const response = await axios.get('/fifth_flow/fifth_analyses', { params });

    return response.data;
  } 
});
export const getFifthAnalysis = asyncThunkWrapper({ 
  model: 'fifthAnalyses', 
  action: 'getFifthAnalysis', 
  func: async ({ id, cable = false }) => {
    const attributes = ['id', 'input', 'result', 'status', 'updated_at'];
    const params = { attributes };
    const response = await axios.get(`/fifth_analyses/${id}`, { params });

    return { data: response.data, cable }
  } 
});
export const clearLocalFifthAnalyses = createAction('fifthAnalyses/clearLocalFifthAnalyses');
export const clearLocalActiveFifthAnalysis = createAction('fifthAnalyses/clearLocalActiveFifthAnalysis');